/* eslint-disable no-duplicate-imports */
import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import queryString from 'query-string';
import { IRequestContext, ITelemetry } from '@msdyn365-commerce/core';

export type PepperjamConfig = {
    programId: string;
    integrationType: string;
};

type PepperjamPixelProps = {
    order: SalesOrder;
    config: PepperjamConfig;
    request: IRequestContext;
    telemetry: ITelemetry;
};

type PepperjamPixelCookieValue = {
    id?: string;
    days?: number;
    type?: string;
};

const pjnCoookieName = 'pjn-click';
const PEPPERJAM_URI = 'https://t.pepperjamnetwork.com/track';

const PepperjamPixel = ({ order, config, request }: PepperjamPixelProps) => {
    const { integrationType, programId } = config;

    const pjnClickIds = request.cookies.get<PepperjamPixelCookieValue[]>(pjnCoookieName)?.value;

    const pepperjamParams = React.useMemo(() => {
        if (!pjnClickIds) {
            return;
        }

        const refId = order.ChannelReferenceId;
        const clickId = (pjnClickIds && pjnClickIds[0] && pjnClickIds[0].id) || '';

        if (!clickId || !refId || !integrationType || !programId || !order.SalesLines) {
            return null;
        }

        const params = {
            INT: config.integrationType,
            PROGRAM_ID: config.programId,
            ORDER_ID: refId,
            CLICK_ID: clickId
        };

        const promoCodes = [];

        let itemOrd = 0;
        for (let i = 0; i < order.SalesLines.length; ++i) {
            const line = order.SalesLines[i];
            if (line.ItemId && line.Quantity && line.Quantity > 0) {
                itemOrd++;
                params[`ITEM_ID${itemOrd}`] = line.ItemId;
                params[`ITEM_PRICE${itemOrd}`] = `${line.NetAmount || 0}`;
                params[`QUANTITY${itemOrd}`] = `${line.Quantity || 0}`;
            }

            if (line.DiscountLines) {
                for (const discountLine of line.DiscountLines) {
                    if (discountLine.DiscountCode) {
                        promoCodes.push(discountLine.DiscountCode);
                    }
                }
            }
        }

        if (promoCodes.length > 0) {
            params['COUPON'] = promoCodes.join(',');
        }

        if (!itemOrd) {
            return null;
        }

        return params;
    }, [order, integrationType, programId, pjnClickIds]);

    if (!pepperjamParams) {
        return null;
    }

    const iframeSrc = `${PEPPERJAM_URI}?${queryString.stringify(pepperjamParams)}`;
    return <iframe id='pjn-pixel' src={iframeSrc} width='1' height='1' frameBorder='0' sandbox='allow-scripts' />;
};

export { PepperjamPixel };
